export default defineNuxtPlugin((_nuxtApp) => {
  const previousRoute = useState<string | null>("previousRoute", () => null);

  const router = useRouter();
  router.beforeEach((to, from) => {
    previousRoute.value = from.name as string | null;
  });
});
